import { DELETE_TYPE } from '@/utils/enum';
import BaseModel from './Base.model';
import { ProductModel } from './Product.model';

export class OrderCanNotServeProductModel extends BaseModel {
  constructor(data = {}) {
    super({
      id: data.id || null,
      createdAt: data.createdAt || null,
      updatedAt: data.updatedAt || null,
    });

    this.orderCanNotServeId = data.orderCanNotServeId || null;
    this.productId = data.productId || null;
    this.productName = data.productName || '';
    this.reasonId = data.reasonId || null;
    this.description = data.description || '';
    this.deleted = data.deleted || DELETE_TYPE.AVAILABLE;

    // Relations
    this.product = ProductModel.fromJson(data.product || {});

    // Additional computed fields
    this.productCode = this.product?.code || null;
  }

  static fromJson(data) {
    if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
      return new OrderCanNotServeProductModel();
    }
    return new OrderCanNotServeProductModel(data);
  }

  static fromJsonArray(dataArray) {
    if (!Array.isArray(dataArray)) {
      return [];
    }
    return dataArray.map((item) => OrderCanNotServeProductModel.fromJson(item));
  }
}
